import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  markAllNotificationsRead,
  markNotificationRead,
  subscribeNotifications,
} from '../notifications/notificationStore';

export function useNotificationCenter(userId) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!userId) {
      setItems([]);
      return undefined;
    }
    return subscribeNotifications(userId, setItems);
  }, [userId]);

  const unreadCount = useMemo(() => items.filter((n) => !n.read).length, [items]);

  const markRead = useCallback(
    async (itemId) => {
      if (!userId || !itemId) return;
      await markNotificationRead(userId, itemId);
    },
    [userId]
  );

  const markAllRead = useCallback(async () => {
    if (!userId) return;
    await markAllNotificationsRead(userId);
  }, [userId]);

  return {
    items,
    unreadCount,
    open,
    setOpen,
    markRead,
    markAllRead,
  };
}
